import React from 'react';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import colors from '../theme';

function Layout({ children }) {
    return (
        <div style={{ minHeight: '100vh', backgroundColor: colors.background }}>
            <TopBar />
            <Sidebar />

            {/* Main content area - adjusted for 70px sidebar */}
            <div style={{
                marginLeft: '150px',
                marginRight: '80px',
                marginTop: '64px',
                minHeight: 'calc(100vh - 64px)'
            }}>
                {children}
            </div>
        </div>
    );
}

export default Layout;